import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import {
  BaseInside,
  BaseLeft,
  BaseRight,
  BaseTop,
  BasesContainer,
  BasesOutsContainer,
  Container,
  Count,
  Inning,
  InningArrows,
  NumbersContainer,
  NumbersBottomContainer,
  NumbersTopContainer,
  Out,
  Outs,
  Points,
  TeamContainer,
  TeamImage,
  TeamImageContainer,
  Wrapper,
} from './styles';

function BaseballMlb({ data }) {
  const { awayTeam, balls, bases, homeTeam, inning, outs, strikes } = data;

  return (
    <>
      <FontFamilyHeader family={FONT_FAMILY.gothamXNarrow} />
      <Container>
        <svg
          width="6"
          height="105"
          viewBox="0 0 6 105"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 0V104.992C2.56099 105.119 1.1848 103.828 0 98.2422V5.99952C1.60438 1.70902 2.99117 0.602145 6 0Z"
            fill="url(#paint0_linear_2825_57)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2825_57"
              x1="3"
              y1="0"
              x2="3"
              y2="104.992"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#E3E5E6" />
              <stop offset="1" stop-color="#BBBFC2" />
            </linearGradient>
          </defs>
        </svg>
        <Wrapper>
          <TeamContainer
            style={{
              background: `linear-gradient(0deg, ${homeTeam.color} 0%, ${Color(
                homeTeam.color
              ).lighten(0.5)} 100%)`,
            }}
          >
            <TeamImageContainer>
              {homeTeam.image && (
                <TeamImage alt="Home Team logo" src={homeTeam.image} />
              )}
            </TeamImageContainer>
            <Points>{homeTeam.points}</Points>
          </TeamContainer>
          <TeamContainer
            style={{
              background: `linear-gradient(0deg, ${awayTeam.color} 0%, ${Color(
                awayTeam.color
              ).lighten(0.5)} 100%)`,
            }}
          >
            <Points>{awayTeam.points}</Points>
            <TeamImageContainer>
              {awayTeam.image && (
                <TeamImage alt="Home Team logo" src={awayTeam.image} />
              )}
            </TeamImageContainer>
          </TeamContainer>
          <NumbersContainer>
            <NumbersTopContainer>
              <BasesOutsContainer>
                <BasesContainer>
                  <BaseRight>{bases[0] && <BaseInside />}</BaseRight>
                  <BaseTop>{bases[1] && <BaseInside />}</BaseTop>
                  <BaseLeft>{bases[2] && <BaseInside />}</BaseLeft>
                </BasesContainer>
              </BasesOutsContainer>
              <Inning>
                <InningArrows>
                  <svg
                    width="16"
                    height="10"
                    viewBox="0 0 16 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 0L16 9.5H0L8 0Z"
                      fill={inning.half === 'top' ? '#000000' : '#B6B6B6'}
                    />
                  </svg>
                  <svg
                    width="16"
                    height="10"
                    viewBox="0 0 16 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 9.5L16 0H0L8 9.5Z"
                      fill={inning.half === 'bottom' ? '#000000' : '#B6B6B6'}
                    />
                  </svg>
                </InningArrows>
                {inning.number}
              </Inning>
            </NumbersTopContainer>
            <NumbersBottomContainer>
              <Outs>
                <Out active={outs >= 1} />
                <Out active={outs >= 2} />
              </Outs>
              <Count>
                {balls} - {strikes}
              </Count>
            </NumbersBottomContainer>
          </NumbersContainer>
        </Wrapper>
        <svg
          width="6"
          height="105"
          viewBox="0 0 6 105"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0V104.992C3.43901 105.119 4.8152 103.828 6 98.2422V5.99953C4.39562 1.70902 3.00883 0.602145 0 0Z"
            fill="url(#paint0_linear_2825_58)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2825_58"
              x1="3"
              y1="0"
              x2="3"
              y2="104.992"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#E3E5E6" />
              <stop offset="1" stop-color="#BBBFC2" />
            </linearGradient>
          </defs>
        </svg>
      </Container>
    </>
  );
}

BaseballMlb.propTypes = {
  data: PropTypes.shape({
    homeTeam: PropTypes.shape({
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    awayTeam: PropTypes.shape({
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    inning: PropTypes.shape({
      number: PropTypes.number,
      half: PropTypes.string,
    }),
    balls: PropTypes.number,
    strikes: PropTypes.number,
    outs: PropTypes.number,
    bases: PropTypes.arrayOf(PropTypes.bool),
  }),
};

BaseballMlb.defaultProps = {
  data: {
    awayTeam: { name: 'Away', points: 0 },
    balls: 0,
    bases: [false, false, false],
    homeTeam: { name: 'Home', points: 0 },
    inning: { number: 1, half: 'Top' },
    outs: 0,
    strikes: 0,
  },
};

export default BaseballMlb;
